import { cn } from '@atlas/ui-primitives'
import { SafeHtml } from '@/components/ui/SafeHtml'

/**
 * Rich text an external system wrote (a Workfront description field, the adaptation needs),
 * sanitised and with its markdown emphasis rendered. A long unbroken run, such as a Vault link,
 * wraps anywhere rather than widening the page.
 */
export function ExternalHtml({ html, className }: { html: string; className?: string }) {
	return (
		<SafeHtml
			html={html}
			markdownEmphasis
			className={cn(
				'wrap-anywhere text-sm leading-relaxed text-ds-text [&_a]:text-ds-primary [&_ol]:list-decimal [&_ol]:pl-5 [&_ul]:list-disc [&_ul]:pl-5',
				className,
			)}
		/>
	)
}
